import { render, staticRenderFns } from "./TableSetting.vue?vue&type=template&id=6769928c&"
import script from "./TableSetting.vue?vue&type=script&lang=js&"
export * from "./TableSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports